import ReportScreen from './ReportScreen';

export default ReportScreen;
